import { render, staticRenderFns } from "./BacCustomerWidget.vue?vue&type=template&id=746bfca6&scoped=true&"
import script from "./BacCustomerWidget.vue?vue&type=script&lang=ts&"
export * from "./BacCustomerWidget.vue?vue&type=script&lang=ts&"
import style0 from "./BacCustomerWidget.vue?vue&type=style&index=0&id=746bfca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bfca6",
  null
  
)

export default component.exports